import logger from "../../../utils/logger";
import {
  addKeyResource,
  editKeyResource,
  loadKeyResource,
  loadKeyResources,
  loadKeyResourcesSuccess,
  loadKeyResourceSuccess
} from "../reducer/keyResources";
import * as uiActions from "../reducer/ui";

const loadKeyResourcesFlow = ({ getKeyResourceList }) => ({
  dispatch,
  getState,
}) => (next) => async (action) => {
  next(action);
  if (action.type === loadKeyResources.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await getKeyResourceList();
      dispatch(loadKeyResourcesSuccess(response.data));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const loadKeyResourceFlow = ({ getKeyResourceItem }) => ({
  dispatch,
  getState,
}) => (next) => async (action) => {
  next(action);
  if (action.type === loadKeyResource.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await getKeyResourceItem(action.payload);
      dispatch(loadKeyResourceSuccess(response.data));
      logger()(response.data);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const addKeyResourceFlow = ({ postKeyResource }) => ({ dispatch }) => (
  next
) => async (action) => {
  next(action);
  if (action.type === addKeyResource.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await postKeyResource(action.payload);
      logger()(response.data);
      dispatch(
        uiActions.setToast(response.data.msg)//`Changes ${action.payload.result}ed successfully`)
      );
      dispatch(loadKeyResources());
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const editKeyResourceFlow = ({ postEditKeyResource }) => ({
  dispatch,
  getState,
}) => (next) => async (action) => {
  next(action);
  if (action.type === editKeyResource.type) {
    dispatch(uiActions.setLoading(true));
    try {
      const response = await postEditKeyResource(
        getState().keyResources.keyResourceRequest.linkedTo,
        action.payload
      );
      logger()(response.data);
      dispatch(
        uiActions.setToast(response.data.msg)//`Changes ${action.payload.result}ed successfully`)
      );
      dispatch(loadKeyResources());
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(uiActions.setError(error.response.data.msg));
      } else dispatch(uiActions.setError(error.message));
    }
    dispatch(uiActions.setLoading(false));
  }
};

const keyResourcesFlow = [
  loadKeyResourcesFlow,
  loadKeyResourceFlow,
  addKeyResourceFlow,
  editKeyResourceFlow,
];

export default keyResourcesFlow;
